export default __webpack_public_path__ + "static/media/logo.b8f1448c.svg";